/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ MenuDrawer; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4076);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      open: 'menu-drawer--open',
      opening: 'menu-drawer--opening',
      closing: 'menu-drawer--closing'
    };
    this.mainDetailsToggle = this.querySelector('details');
    this.submenuOpenTimeouts = new WeakMap();
    this.submenuOpenAnimationFrames = new WeakMap();
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }
  setClasses(classes) {
    this.classes = classes;
  }
  scheduleSubmenuOpen(detailsElement, callback, delay) {
    this.cancelSubmenuOpen(detailsElement);
    const timeout = setTimeout(() => {
      this.submenuOpenTimeouts.delete(detailsElement);
      if (!detailsElement.hasAttribute('open')) return;
      callback();
    }, delay);
    this.submenuOpenTimeouts.set(detailsElement, timeout);
  }
  scheduleSubmenuTransition(detailsElement, callback) {
    this.cancelSubmenuOpen(detailsElement);
    const firstFrame = window.requestAnimationFrame(() => {
      const secondFrame = window.requestAnimationFrame(() => {
        this.submenuOpenAnimationFrames.delete(detailsElement);
        if (!detailsElement.hasAttribute('open')) return;
        callback();
      });
      this.submenuOpenAnimationFrames.set(detailsElement, secondFrame);
    });
    this.submenuOpenAnimationFrames.set(detailsElement, firstFrame);
  }
  hasScheduledSubmenuOpen(detailsElement) {
    return this.submenuOpenTimeouts.has(detailsElement) || this.submenuOpenAnimationFrames.has(detailsElement);
  }
  cancelSubmenuOpen(detailsElement) {
    const timeout = this.submenuOpenTimeouts.get(detailsElement);
    if (timeout !== undefined) {
      clearTimeout(timeout);
      this.submenuOpenTimeouts.delete(detailsElement);
    }
    const animationFrame = this.submenuOpenAnimationFrames.get(detailsElement);
    if (animationFrame !== undefined) {
      window.cancelAnimationFrame(animationFrame);
      this.submenuOpenAnimationFrames.delete(detailsElement);
    }
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button[data-close]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.addEventListener('drawer:force-close', event => {
      event.stopPropagation();
      this.closeMenuDrawer(event);
    });
  }
  onKeyUp(event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .trapFocus */ .St)(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    function openSubmenu() {
      detailsElement.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', true);
      !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      if (isOpen) {
        event.preventDefault();
        this.closeSubmenu(detailsElement);
        return;
      }
      if (detailsElement.closest('.menu-drawer__menu--lvl1 > li > details') === detailsElement && !isOpen) {
        this.mainDetailsToggle.querySelectorAll('.menu-drawer__menu--lvl1 > li > details').forEach(details => {
          if (details !== detailsElement && this.hasScheduledSubmenuOpen(details)) {
            this.closeSubmenu(details, true);
          }
        });
        const hasOpenLevelTwo = this.mainDetailsToggle.querySelector('.menu-drawer__menu--lvl1 > li > details[open]') !== null;
        const closeOtherSubmenus = () => {
          this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
            if (details !== detailsElement && details.hasAttribute('open')) {
              this.closeSubmenu(details, true);
            }
          });
        };
        if (hasOpenLevelTwo) {
          this.scheduleSubmenuTransition(detailsElement, () => {
            openSubmenu();
            closeOtherSubmenus();
          });
        } else {
          closeOtherSubmenus();
          this.scheduleSubmenuOpen(detailsElement, openSubmenu, 100);
        }
      } else {
        this.scheduleSubmenuOpen(detailsElement, openSubmenu, 100);
      }
    }
  }
  openMenuDrawer(summaryElement = false) {
    (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .setScrollbarWidth */ .pp)();
    (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .setHeaderBottomPosition */ .u$)();
    if (summaryElement) {
      summaryElement.setAttribute('aria-expanded', true);
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .trapFocus */ .St)(this.mainDetailsToggle, summaryElement);
    }
    setTimeout(() => {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
    document.body.classList.add(this.classes.opening);
    this.openAnimation();
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }, 10);
    });
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        this.cancelSubmenuOpen(details);
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeTrapFocus */ .zx)(elementToFocus);
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);
      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent('close'));
      document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }
  }
  onFocusOut() {
    if (!this.mainDetailsToggle) return;
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains('noclose')) return;
    const detailsElement = target.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement, immediately = false) {
    this.cancelSubmenuOpen(detailsElement);
    const summaryElement = detailsElement.querySelector('summary');
    const submenuElement = summaryElement.nextElementSibling;
    const inlineTransition = submenuElement.style.transition;
    if (immediately) submenuElement.style.transition = 'none';
    detailsElement.classList.remove('menu-opening');
    summaryElement.setAttribute('aria-expanded', false);
    (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .removeTrapFocus */ .zx)();
    if (immediately) {
      submenuElement.getBoundingClientRect();
      detailsElement.removeAttribute('open');
      inlineTransition ? submenuElement.style.transition = inlineTransition : submenuElement.style.removeProperty('transition');
    } else {
      this.closeAnimation(detailsElement);
    }
  }
  openAnimation() {
    let animationStart;
    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          detailsElement.classList.remove('menu-closing');
        }
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .trapFocus */ .St)(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}
if (!customElements.get('menu-drawer')) {
  customElements.define('menu-drawer', MenuDrawer);
}
class CartDrawer extends MenuDrawer {
  constructor() {
    super();
    this.setClasses({
      open: 'mini-cart--open',
      opening: 'mini-cart--opening',
      closing: 'mini-cart--closing'
    });
  }
}
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
class FacetDrawer extends MenuDrawer {
  constructor() {
    super();
    if (this.dataset.desktop == 'true') {
      this.setClasses({
        open: 'facet-horizontal--open',
        opening: 'facet-horizontal--opening',
        closing: 'facet-horizontal--closing'
      });
    } else {
      this.setClasses({
        open: 'facet-drawer--open',
        opening: 'facet-drawer--opening',
        closing: 'facet-drawer--closing'
      });
    }
  }
}
if (!customElements.get('facet-drawer')) {
  customElements.define('facet-drawer', FacetDrawer);
}
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.setClasses({
      open: 'menu-mobile--open',
      opening: 'menu-mobile--opening',
      closing: 'menu-mobile--closing'
    });
  }
}
if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', HeaderDrawer);
}

/***/ }),

/***/ 4076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   St: function() { return /* binding */ trapFocus; },
/* harmony export */   pp: function() { return /* binding */ setScrollbarWidth; },
/* harmony export */   u$: function() { return /* binding */ setHeaderBottomPosition; },
/* harmony export */   zx: function() { return /* binding */ removeTrapFocus; }
/* harmony export */ });
/* unused harmony exports pauseAllMedia, debounce, fetchConfig, isStorageSupported, checkScrollbar, getFocusableElements, filterShopifyEvent */
function pauseAllMedia() {
  document.querySelectorAll('iframe.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('iframe.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video-section[data-type="youtube"]:not([data-video-hero]) iframe').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('video-section[data-type="vimeo"]:not([data-video-hero]) iframe').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => {
    if (!video.closest('[data-video-hero]')) video.pause();
  });
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}
function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }
  const testKey = 'beyours:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}
function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}
function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    element.className = 'modal-scrollbar-measure', document.body.appendChild(element);
    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
  }
}
function setHeaderBottomPosition() {
  const header = document.querySelector('.shopify-section-header');
  if (header) {
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom)}px`);
  }
}
function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
    if (charCode !== 'TAB') return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if (!elementToFocus) return;
  elementToFocus.focus();
  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes('shopify:section')) {
    if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
      executeCallback = true;
    }
  } else if (event.type.includes('shopify:block') && event.target === domElement) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {

// EXTERNAL MODULE: ./src/js/entrypoint/global/menu-drawer.js
var menu_drawer = __webpack_require__(938);
;// CONCATENATED MODULE: ./src/js/utils/HTMLUpdateUtility.js
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach(callback => callback(newContent));
    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach(element => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';
    postProcessCallbacks?.forEach(callback => callback(newNode));
    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
;// CONCATENATED MODULE: ./src/js/entrypoint/global/quick-view.js


const isIOS = typeof navigator !== 'undefined' && (/iP(ad|hone|od)/.test(navigator.userAgent) || /Mac/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
class QuickViewDrawer extends menu_drawer/* MenuDrawer */._ {
  constructor() {
    super();
    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });
    this.addEventListener('close', () => {
      if (isIOS && document.body.dataset.quickViewScroll) {
        const scrollTop = Number(document.body.dataset.quickViewScroll) || 0;
        delete document.body.dataset.quickViewScroll;
        Object.assign(document.body.style, {
          position: '',
          top: '',
          left: '',
          right: '',
          width: ''
        });
        window.scrollTo(0, scrollTop);
      }
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');
      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  openMenuDrawer(summaryElement = false) {
    if (isIOS && !document.body.dataset.quickViewScroll) {
      const scrollTop = window.scrollY || window.pageYOffset;
      document.body.dataset.quickViewScroll = String(scrollTop);
      Object.assign(document.body.style, {
        position: 'fixed',
        top: `-${scrollTop}px`,
        left: '0',
        right: '0',
        width: '100%'
      });
    }
    super.openMenuDrawer(summaryElement);
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);
class QuickViewButton extends menu_drawer/* MenuDrawer */._ {
  constructor() {
    super();
    this.handleActivate = this.handleActivate.bind(this);
    this.addEventListener('click', this.handleActivate);
    this.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.handleActivate();
      }
    });
  }
  handleActivate() {
    const productId = this.dataset.productId;
    const drawer = document.querySelector(`quick-view-drawer[data-product-id="${productId}"]`);
    if (drawer) {
      drawer.querySelector('summary').click();
      document.dispatchEvent(new CustomEvent('quickview:open', {
        detail: {
          productUrl: this.dataset.productUrl
        }
      }));
    } else if (this.dataset.productUrl) {
      window.location.href = this.dataset.productUrl;
    }
  }
}
customElements.define('quick-view-button', QuickViewButton);
class QuickView extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }
  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;
    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    let sectionUrl = `${productUrl}?view=modal`;
    const productHandle = this.dataset.productHandle;
    const variantId = this.dataset.variantId;
    if (productHandle && variantId) {
      sectionUrl = `${theme.routes.root_url}/products/${productHandle}?variant=${variantId}&view=modal`;
    }
    fetch(sectionUrl).then(response => response.text()).then(responseText => {
      setTimeout(() => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector(selector);
        HTMLUpdateUtility.setInnerHTML(drawerContent, productElement.innerHTML);
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }, 200);
      setTimeout(() => {
        drawerContent.classList.add('hide-cover');
        document.dispatchEvent(new CustomEvent('quickview:loaded', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }, 500);
    }).catch(e => {
      console.error(e);
    });
  }
}
customElements.define('quick-view', QuickView);
}();
/******/ })()
;